import React, { Component } from 'react';
import CompanySpecialBusinessCategoriesTags from './CompanySpecialBusinessCategoriesTags';
import MultistepSelect from "../multistep-select/MultistepSelect";
import { messages } from '../common/Translations';
import {injectIntl} from "react-intl";
import '../../../scss/_placeholder.scss';

class CompanySpecialBusinessCategories extends Component
{
    /**
     * Confirm and add a business category
     * @param businessCategoryId
     * @returns {*}
     */
    onConfirmSelectedBusinessCategory(businessCategoryId) {
        let addedBusinessCategories = this.props.input.value.slice();
        let businessCategories = this.props.categories;

        // list of added ids of business categories
        let addedBusinessCategoryIds = addedBusinessCategories.map((businessCategory) => {
            return businessCategory.id;
        });

        // exit if category already exists
        if (addedBusinessCategoryIds.includes(businessCategoryId)) {
            return this.props.input.onChange(addedBusinessCategories);
        }

        // add a business category tag
        for (let businessCategory of businessCategories) {
            if (businessCategory.id === businessCategoryId) {
                addedBusinessCategories.push({
                    id: businessCategory.id,
                    name: businessCategory.name,
                    parentId: businessCategory.parentId
                });
            }
        }

        return this.props.input.onChange(addedBusinessCategories);
    }

    /**
     * Removes a special business category from tags list
     * @param businessCategoryId
     * @returns {*}
     */
    onRemoveBusinessCategory(businessCategoryId) {
        let filteredBusinessCategories = this.props.input.value.filter((businessCategory) => {
            return businessCategory.id !== businessCategoryId;
        });

        return this.props.input.onChange(filteredBusinessCategories);
    }

    /**
     * Renders special business categories select
     * @returns {*}
     */
    render() {
        return (
            <div className={"form-group row"} id={`div_${this.props.input.name}`}>
                <label className="col-sm-2 col-form-label">
                    <b>Speciel branche kategori</b>
                </label>

                <div className="col-sm-10">
                    <MultistepSelect
                        data={this.props.categories}
                        selection={this.props.input.value}
                        onConfirm={this.onConfirmSelectedBusinessCategory.bind(this)}
                        onRemove={this.onRemoveBusinessCategory.bind(this)}
                        selectedListComponent={CompanySpecialBusinessCategoriesTags}
                        confirmBtnRootMsg={messages.multistepSelectButtonSelectionPlaceholder}
                        confirmBtnSubMsg={messages.companyFormKeywordsConfirmBtnTextSubItem}
                    >
                        {(selects, selection, buttons) => {
                            return (
                                <div>
                                    {selection}
                                    <div className="CompanyKeywords-input">{selects}</div>
                                    {buttons}
                                </div>
                            );
                        }}
                    </MultistepSelect>
                </div>

            </div>
        );
    }
}

export default injectIntl(CompanySpecialBusinessCategories);


// WEBPACK FOOTER //
// ./web/src/components/company/CompanySpecialBusinessCategories.jsx